import { useEffect } from 'react';
import type { EvaluatedCell } from 'models/interfaces/spreadsheet-types/core-types';
import { EXCHANGE_RATE_ALIAS, EXCHANGE_RATE_SHEET_NAME } from './ExchangeRateSheet.constants';
import type { UseExchangeRateSheetProps } from './UseExchangeRateSheet.props';

export const useExchangeRateSheet = ({ cells, onChange, exchangeRate }: UseExchangeRateSheetProps) => {
  // Keep workbook formulas aligned with both pending and resolved FX states.
  useEffect(() => {
    if (onChange && cells) {
      const cell = cells[EXCHANGE_RATE_SHEET_NAME]?.[EXCHANGE_RATE_ALIAS] as EvaluatedCell;
      if (cell && cell.value !== exchangeRate) {
        onChange(cell, exchangeRate);
      }
    }
  }, [exchangeRate, onChange, cells]);
};
